import React from "react";
import EditSubject from "./EditSubject";
import { ISubjectId } from "../../Subject.props";

const EditSubjectIndex: React.FC<ISubjectId> = ({ subjectId,setSelectedSubjectId }) => {
  return <EditSubject subjectId={subjectId} setSelectedSubjectId={setSelectedSubjectId} />;
};

export default EditSubjectIndex;
